var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-costs',{attrs:{"value":_vm.adaptedValue,"currency":_vm.currency,"kid-type":_vm.nonPureKidTypeSentinel,"is-mop":_vm.isMop,"hide-maturity-costs":"","first-period-label":_vm.firstPeriodLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }